import { render, staticRenderFns } from "./AgreementPollboxAge.vue?vue&type=template&id=5ad1c2e3&"
import script from "./AgreementPollboxAge.vue?vue&type=script&lang=js&"
export * from "./AgreementPollboxAge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports